"use client";

import React from "react";
import FAQ from "@/components/tools/FAQ";

const homeFAQs = [
  {
    question: "Are you accepting new patients?",
    answer:
      "Yes. We welcome new patients of all ages at our Astoria location. Call (718) 400-4400 or book online to schedule your first visit.",
  },
  {
    question: "Do you accept dental insurance?",
    answer:
      "We accept most major PPO insurance plans. Our team will help verify your benefits before your appointment. We also offer flexible financing options.",
    links: [
      {
        text: "flexible financing options",
        url: "/financing-insurance/",
      },
    ],
  },
  {
    question: "Where are you located?",
    answer:
      "If you're searching for a dentist near you in Astoria, Smile4Me Dental Care is located at 31-57 Steinway St, Queens, NY 11103.",
  },
  {
    question: "How do I book an appointment at Smile4Me?",
    answer:
      "You can book online anytime, or call us directly at (718) 400-4400. We offer same-day appointments for dental emergencies.",
    links: [
      {
        text: "book online",
        url: "https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a",
      },
    ],
  },
];

const HomeFAQ: React.FC = () => {
  return <FAQ title="Frequently Asked Questions" faqs={homeFAQs} />;
};

export default HomeFAQ;
